var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-log-in-19x19",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, -0.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,16 L11.3939193,18.402606 C10.8862895,18.6201616 10.2984106,18.3850101 10.080855,17.8773803 C10.0275077,17.7529034 10,17.6188878 10,17.483461 L10,16 L5,16 C4.44771525,16 4,15.5522847 4,15 L6,13 C6,7.66666667 6,5 6,5 C6,5 5.33333333,4.32527669 4,2.97583008 L4,1 C4,0.44771525 4.44771525,-1.41094017e-14 5,-1.42108547e-14 L17,-1.42108547e-14 L17,16 Z M12.3333333,2 L6,2 L6,14 L10,14 L10,3.65939616 C10,3.25936805 10.2383969,2.89782992 10.6060807,2.74025113 L12.3333333,2 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,7.51318359 L4,5 L8,9 L4,13 L4,10.5131836 L-1,10.5131836 L-1,7.51318359 L4,7.51318359 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.eb671ba2497d170126826c79000515ae.svg";
export { ForwardRef as ReactComponent };